export default __webpack_public_path__ + "static/media/Cross Blade_ Shockwave_ Heated Weapon.fbd520d6.png";